import './ReactAdminContainer.scss';
const ReactAdminContainer = ({children}) =>
{

    if (Array.isArray(children))
    {
        return (
            <div className='react-admin-container'>
                {children.map((child, key) =>
                {
                    return <div className='react-admin-container-child' key={key}>{child}</div>
                })}
            </div>
        )
    }
    else {
        return (
            <div className='react-admin-container'>
                <div className='react-admin-container-child'>{children}</div>
            </div>
        )
    }


}

export default ReactAdminContainer;